<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<nav-bar>
	<div class="top-right-menu account-top-right-menu">
		<!-- Profile Menu -->
		<dropdown-menu #parent>
			<div dropdown-label>
				<div class="nav-bar-menu-item" [ngClass]="{ 'nav-bar-menu-item-expanded': parent.opened$ | async }">
					<span>{{ (appState.user | async)?.parsedName }}</span>
					<span *ngIf="!(parent.opened$ | async)" class="nav-bar-menu-dropdown-icon"
						><i class="material-icons notranslate">keyboard_arrow_down</i></span
					>
					<span *ngIf="parent.opened$ | async" class="nav-bar-menu-dropdown-icon"
						><i class="material-icons notranslate">keyboard_arrow_up</i></span
					>
				</div>
			</div>

			<div dropdown-content class="nav-bar-dropdown-menu no-print">
				<div (click)="goToDashboard()" class="nav-bar-dropdown-menu-item" automationId="navDropdownInsights">
					<i class="material-icons">dashboard</i>Insights
				</div>
				<div
					*ngIf="isOrgAdmin$ | async"
					(click)="openAPISettings()"
					class="nav-bar-dropdown-menu-item"
					automationId="navDropdownApiSettings"
				>
					<i class="material-icons">code</i>{{ appStrings.API_SETTINGS }}
				</div>
				<div (click)="goToMobile()" class="nav-bar-dropdown-menu-item" automationId="navDropdownMobileSite">
					<i class="material-icons">smartphone</i>Mobile Site
				</div>
				<div (click)="logout()" class="nav-bar-dropdown-menu-item" automationId="navDropdownLogOut">
					<i class="material-icons">exit_to_app</i>Log Out
				</div>
			</div>
		</dropdown-menu>
		<!-- Exit Account Settings Page -->
		<div (click)="goBack()" class="nav-bar-menu-item exit-account" automationId="exitAccountSettings">
			Exit Account Settings
		</div>

		<!-- Support Menu -->
		<support-menu></support-menu>
	</div>
</nav-bar>
